import React from 'react';
import proptypes from 'prop-types';
import { Accordion, AccordionHeader, } from '@one-thd/sui-atomic-components';

const { string } = proptypes;

export const InfoBoxLink = ({
  title,
  href,
  target
}) => {

  return (
    <a href={href} target={target}>
      <Accordion expanded={false}>
        <AccordionHeader>
          {title}
        </AccordionHeader>
      </Accordion>
    </a>
  );
};

InfoBoxLink.propTypes = {
  title: string.isRequired,
  href: string,
  target: string
};

InfoBoxLink.defaultProps = {
  href: '',
  target: '_blank'
};
